module.exports = __webpack_public_path__ + "static/media/ebema-main_logo.19aa9e4c.jpg";